@switch (buttonType) {
    <!-- BASIC -->
    @case (MatButtonAvailableType.BASIC) {
        <button
            mat-button
            [color]="AMColor"
            [class]="buttonClass"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabelButton"
            (click)="showDialog()">
            @if (withIcon) {
                <mat-icon>{{ iconName }}</mat-icon>
            }
            {{ buttonText }}
        </button>
    }
    <!-- RAISED -->
    @case (MatButtonAvailableType.RAISED) {
        <button
            mat-raised-button
            [color]="AMColor"
            [class]="buttonClass"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabelButton"
            (click)="showDialog()">
            @if (withIcon) {
                <mat-icon>{{ iconName }}</mat-icon>
            }
            {{ buttonText }}
        </button>
    }
    <!-- STROKED -->
    @case (MatButtonAvailableType.STROKED) {
        <button
            mat-stroked-button
            [color]="AMColor"
            [class]="buttonClass"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabelButton"
            (click)="showDialog()">
            @if (withIcon) {
                <mat-icon>{{ iconName }}</mat-icon>
            }
            {{ buttonText }}
        </button>
    }
    <!-- FLAT -->
    @case (MatButtonAvailableType.FLAT) {
        <button
            mat-flat-button
            [color]="AMColor"
            [class]="buttonClass"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabelButton"
            (click)="showDialog()">
            @if (withIcon) {
                <mat-icon>{{ iconName }}</mat-icon>
            }
            {{ buttonText }}
        </button>
    }
    <!-- ICON -->
    @case (MatButtonAvailableType.ICON) {
        <button
            mat-icon-button
            [color]="AMColor"
            [class]="buttonClass"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabelButton"
            (click)="showDialog()">
            <mat-icon>{{ iconName }}</mat-icon>
            <!-- No content possible with ICON button -->
        </button>
    }
    <!-- FAB -->
    <!-- FAB button can be extended -->
    @case (MatButtonAvailableType.FAB) {
        <button
            mat-fab
            [color]="AMColor"
            [class]="buttonClass"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabelButton"
            [extended]="fabExtended"
            (click)="showDialog()">
            <!-- FAB button always needs to have an icon -->
            <mat-icon>{{ iconName }}</mat-icon>
            <!-- Content only possible when the button is extended -->
            @if (fabExtended) {
                {{ buttonText }}
            }
        </button>
    }
    <!-- MINI_FAB -->
    @case (MatButtonAvailableType.MINI_FAB) {
        <button
            mat-mini-fab
            [color]="AMColor"
            [class]="buttonClass"
            [disabled]="disabled"
            [attr.aria-label]="ariaLabelButton"
            (click)="showDialog()">
            <!-- FAB_MINI button always needs to have an icon -->
            <mat-icon>{{ iconName }}</mat-icon>
            <!-- No content possible with MINI_FAB button -->
        </button>
    }
}
